import React from 'react';
import { Star } from 'lucide-react';

const Stars = ({ rating }) =>
  Array.from({ length: 5 }, (_, i) => (
    <Star
      key={i}
      size={16}
      className={`star ${i < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
    />
  ));

export const TestimonialCard = ({ testimonial, centerLayout = false }) => (
  <div className="testimonial-card" style={centerLayout ? { maxWidth: '400px', margin: '0 auto' } : undefined}>
    <div className="testimonial-quote">"</div>

    <div
      className="testimonial-rating"
      style={{
        marginBottom: '1rem',
        ...(centerLayout && { display: 'flex', justifyContent: 'center' })
      }}
    >
      <Stars rating={testimonial.rating} />
    </div>

    <blockquote className="testimonial-text" style={centerLayout ? { textAlign: 'center' } : undefined}>
      {testimonial.text}
    </blockquote>

    <div
      className="testimonial-author"
      style={
        centerLayout
          ? { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }
          : undefined
      }
    >
      <div className="testimonial-avatar">{testimonial.avatar}</div>
      <div className={centerLayout ? undefined : 'testimonial-info'} style={centerLayout ? { textAlign: 'center' } : undefined}>
        <h4>{testimonial.name}</h4>
        <p>{testimonial.role}</p>
        <p style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{testimonial.location}</p>
        {!centerLayout && (
          <div
            style={{
              display: 'inline-block',
              marginTop: '0.5rem',
              padding: '0.25rem 0.75rem',
              background: 'var(--accent-gold-dark)',
              color: 'white',
              borderRadius: '1rem',
              fontSize: '0.75rem',
              fontWeight: 600
            }}
          >
            {testimonial.service}
          </div>
        )}
      </div>
    </div>
  </div>
);
